var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductionSupport2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2161.55 1482.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{opacity:0.64;}.cls-5{fill:#bdd0fb;}.cls-6{fill:#dce5fe;}.cls-7{opacity:0.91;}.cls-8{fill:#7d97f4;}.cls-9{fill:#18174a;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:#2b69b3;}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:#fff;}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:url(#linear-gradient-26);}.cls-36{fill:url(#linear-gradient-27);}.cls-37{fill:url(#linear-gradient-28);}.cls-38{fill:url(#linear-gradient-29);}.cls-39{fill:url(#linear-gradient-30);}.cls-40{fill:url(#linear-gradient-31);}.cls-41{fill:url(#linear-gradient-32);}.cls-42{fill:url(#linear-gradient-33);}.cls-43{fill:url(#linear-gradient-34);}.cls-44{fill:url(#linear-gradient-35);}.cls-45{fill:url(#linear-gradient-36);}.cls-46{fill:url(#linear-gradient-37);}.cls-47{fill:url(#linear-gradient-38);}.cls-48{fill:url(#linear-gradient-39);}.cls-49{fill:url(#linear-gradient-40);}.cls-50{fill:url(#linear-gradient-41);}.cls-51{fill:url(#linear-gradient-42);}.cls-52{fill:url(#linear-gradient-43);}.cls-53{fill:url(#linear-gradient-44);}.cls-54{fill:url(#linear-gradient-45);}.cls-55{fill:url(#linear-gradient-46);}.cls-56{fill:url(#linear-gradient-47);}.cls-57{fill:url(#linear-gradient-48);}.cls-58{fill:url(#linear-gradient-49);}.cls-59{fill:url(#linear-gradient-50);}.cls-60{fill:url(#linear-gradient-51);}.cls-61{fill:url(#linear-gradient-52);}.cls-62{fill:url(#linear-gradient-53);}.cls-63{fill:url(#linear-gradient-54);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1772.35,
    y1: 734.04,
    x2: 389.2,
    y2: 734.04,
    gradientTransform: "matrix(-1, 0, 0, 1, 389.2, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1699.4,
    y1: 14.45,
    x2: 1534.39,
    y2: 308.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 711.15,
    y1: 1334.16,
    x2: 856.34,
    y2: 1334.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 711.15,
    y1: 1187.21,
    x2: 714.96,
    y2: 1187.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 835.34,
    y1: 521.24,
    x2: 1100.82,
    y2: 521.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1020.76,
    y1: 411.34,
    x2: 681.88,
    y2: 915.85,
    gradientTransform: "translate(1336.56 -528.33) rotate(82.98)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1078.63,
    y1: 450.21,
    x2: 739.75,
    y2: 954.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1149.31,
    y1: 425.57,
    x2: 1415.57,
    y2: 425.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1149.31,
    y1: 464.52,
    x2: 1415.57,
    y2: 464.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1149.31,
    y1: 504.03,
    x2: 1415.57,
    y2: 504.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 837.07,
    y1: 694.57,
    x2: 1439.79,
    y2: 694.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 837.07,
    y1: 733.52,
    x2: 1439.79,
    y2: 733.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 832.12,
    y1: 824.87,
    x2: 915.2,
    y2: 824.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 932.57,
    y1: 822.1,
    x2: 1082.5,
    y2: 822.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1124.88,
    y1: 824.87,
    x2: 1207.96,
    y2: 824.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1225.33,
    y1: 822.1,
    x2: 1375.26,
    y2: 822.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 857.85,
    y1: 956.38,
    x2: 919.33,
    y2: 956.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 959.75,
    y1: 959.02,
    x2: 1440.21,
    y2: 959.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1011.95,
    y1: 734.83,
    x2: 758.74,
    y2: 1167,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 857.85,
    y1: 1062.66,
    x2: 919.33,
    y2: 1062.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 959.75,
    y1: 1065.3,
    x2: 1440.21,
    y2: 1065.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 857.85,
    y1: 1168.94,
    x2: 919.33,
    y2: 1168.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 959.75,
    y1: 1171.58,
    x2: 1440.21,
    y2: 1171.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1097.29,
    y1: 868.52,
    x2: 764.11,
    y2: 1333.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 857.85,
    y1: 1275.22,
    x2: 919.33,
    y2: 1275.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 959.75,
    y1: 1277.85,
    x2: 1440.21,
    y2: 1277.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1236.77,
    y1: 59.46,
    x2: 916.93,
    y2: 480.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1084.7,
    y1: 191.72,
    x2: 1135.93,
    y2: 191.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1271.85,
    y1: 86.13,
    x2: 952.01,
    y2: 506.87,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1054.87,
    y1: 255.27,
    x2: 1069.47,
    y2: 255.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 985.7,
    y1: 271.99,
    x2: 1047.89,
    y2: 271.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1643.29,
    y1: 1367.17,
    x2: 1659.95,
    y2: 1469.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1485,
    y1: 1371.59,
    x2: 1637.66,
    y2: 1229.59,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1739.56,
    y1: 1037.94,
    x2: 1691.56,
    y2: 1253.94,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1674.15,
    y1: 844.16,
    x2: 1698.81,
    y2: 925.49,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1628.16,
    y1: 804.72,
    x2: 1702.82,
    y2: 844.71,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1631.68,
    y1: 798.5,
    x2: 1706.35,
    y2: 838.5,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1885.39,
    y1: 1072.98,
    x2: 1678.05,
    y2: 1108.98,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 392.43,
    y1: 1273.48,
    x2: 408.43,
    y2: 1104.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -572.98,
    y1: 930.07,
    x2: -606.01,
    y2: 1027.23,
    gradientTransform: "matrix(0.86, -0.5, 0.5, 0.86, 645.96, -213.51)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 555.59,
    y1: 1468.61,
    x2: 671.56,
    y2: 1468.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 644.94,
    y1: 1245.6,
    x2: 613.26,
    y2: 1464.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 561.38,
    y1: 1433.66,
    x2: 592.76,
    y2: 1433.66,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 737.49,
    y1: 1445.63,
    x2: 831.13,
    y2: 1445.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 801.9,
    y1: 1268.32,
    x2: 770.21,
    y2: 1487.25,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 710.01,
    y1: 1436.3,
    x2: 747.47,
    y2: 1436.3,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 437.38,
    y1: 828.18,
    x2: 401.38,
    y2: 943.18,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 552.21,
    y1: 991.11,
    x2: 649.85,
    y2: 991.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 545.09,
    y1: 1025.15,
    x2: 353.09,
    y2: 1158.15,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -347.71,
    y1: 2419.7,
    x2: -443.26,
    y2: 2546.1,
    gradientTransform: "translate(-31.8 -1632.68) rotate(-20.41)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -487.65,
    y1: 2519.8,
    x2: -411.01,
    y2: 2441.18,
    gradientTransform: "translate(-31.8 -1632.68) rotate(-20.41)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 419.4,
    y1: 984.77,
    x2: 476.34,
    y2: 984.77,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 360.42,
    y1: 1031.27,
    x2: 455.69,
    y2: 1031.27,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 499.41,
    y1: 1087.27,
    x2: 623.41,
    y2: 987.26,
    xlinkHref: "#linear-gradient-32"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1598.48,106.21c127,147.53,567.67-16.37,563,255.64-5.43,318.51-191,477.81-89.51,721.69,94.67,227.5-223.41,389.17-787,384.44S-185.12,1182.3,33.29,877.16s72.89-320.8,62.24-455.66,99.84-430.67,536.31-184S1276.92-267.41,1598.48,106.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1516.05,
    cy: 338.28,
    r: 87.66,
    transform: "translate(1030.03 1813.62) rotate(-84.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1568.14,319.75a56.31,56.31,0,1,1-52.09-34.91c1,0,1.9,0,2.84.07V270.64c-.94,0-1.89-.06-2.84-.06a70.52,70.52,0,1,0,65.18,43.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1587.48,463.08H1444.62a16.24,16.24,0,1,0,0,32.47h142.86a16.24,16.24,0,0,0,0-32.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1805.35,463.08H1662.49a16.24,16.24,0,0,0,0,32.47h142.86a16.24,16.24,0,0,0,0-32.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1880.36,495.55h142.86a16.24,16.24,0,0,0,0-32.47H1880.36a16.24,16.24,0,0,0,0,32.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1428.38,
    y: 513.59,
    width: 175.33,
    height: 128.08,
    rx: 16.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1646.26,
    y: 513.59,
    width: 175.33,
    height: 128.08,
    rx: 16.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1864.13,
    y: 513.59,
    width: 175.33,
    height: 128.08,
    rx: 16.24
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.41,622.08s-36-26.59-8-118.17c24.6-80.57,51.85-131,86.47-116.75s-22.7,181.93-65.65,234.24c0,0-84.8,807.75,556.69,796.67C790.88,1418.07,189,1538.13,221.41,622.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M223.31,591.15a3,3,0,0,1-2.73-1.7c-16.47-33,10.68-123.28,44.15-176,2.57-4,19.76-19.32,27.07-17S299.74,408,298,415.09a151,151,0,0,1-20.9,47.12,3.05,3.05,0,1,1-5.08-3.39,145,145,0,0,0,20-45.22c1-4,1.27-10.26-2.06-11.31-3.16-.37-17.36,10.2-20.07,14.47-35.68,56.17-57.81,142-43.84,170a3.07,3.07,0,0,1-1.38,4.1A3.12,3.12,0,0,1,223.31,591.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M360.69,271.2c105.7,68.5,704.56,492.23,407.88,1125.62,0,0-466.06-177.47-424.33-1117.18A10.66,10.66,0,0,1,360.69,271.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M404.85,389.81s34,49.88,82,126.64l18.64,30,19.7,32.24c13.42,22.19,27.51,45.64,41.75,70.09s28.8,49.8,43.37,75.7q10.8,19.5,21.72,39.25c7.12,13.25,14.42,26.46,21.44,39.82s14.17,26.66,21,40.07q5.14,10,10.28,20c3.41,6.66,6.68,13.37,10,20s6.61,13.28,9.88,19.88,6.38,13.23,9.54,19.8c6.4,13.09,12.41,26.17,18.36,39,11.88,25.71,22.87,50.79,32.88,74.76s19,46.82,26.8,68.11c4.07,10.59,7.54,20.9,10.9,30.67q2.54,7.34,4.92,14.28c1.54,4.65,2.9,9.21,4.29,13.61,2.7,8.82,5.43,17,7.6,24.69s4.08,14.77,5.84,21.16q1.31,4.8,2.48,9.07c.68,2.87,1.31,5.57,1.9,8.07,1.18,5,2.19,9.28,3,12.74l2.5,10.61a4.07,4.07,0,1,1-7.93,1.86h0l0-.17s-.85-3.66-2.43-10.51c-.78-3.43-1.76-7.66-2.9-12.63-.57-2.48-1.19-5.15-1.84-8l-2.42-9c-1.72-6.35-3.62-13.37-5.7-21s-4.78-15.79-7.42-24.56c-1.36-4.37-2.69-8.91-4.2-13.54L796,1138.3c-3.3-9.74-6.69-20-10.69-30.56-7.66-21.23-16.54-44-26.37-68s-20.68-49-32.4-74.69c-5.88-12.84-11.81-25.91-18.13-39L699,906.28l-9.77-19.88c-3.29-6.65-6.53-13.35-9.89-20l-10.17-20c-6.72-13.42-13.79-26.73-20.74-40.11s-14.16-26.61-21.21-39.86-14.38-26.3-21.5-39.31c-14.43-25.94-28.77-51.39-43-75.83s-28.06-48-41.36-70.23q-10.07-16.62-19.53-32.3l-18.48-30.05c-11.91-19.23-22.93-36.79-32.8-52.29s-18.54-29-25.73-40c-14.4-22.11-22.82-34.6-22.82-34.6a1.72,1.72,0,0,1,2.85-1.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2116.8,452.23c9.44,128.65,33.8,879.56-666.73,1029,0,0-143.3-490.22,649.67-1037.2A10.91,10.91,0,0,1,2116.8,452.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2047.24,561.61s-19.68,58.63-52.66,145.28q-6.22,16.23-12.95,33.76t-14.14,36c-9.82,24.67-20.25,50.67-31.41,77.41s-22.86,54.31-35,82.22q-9.24,20.87-18.62,42c-6.41,14-12.69,28.12-19.25,42.12s-13,28.05-19.75,41.89l-10,20.77c-3.33,6.9-6.78,13.72-10.14,20.55L1813.22,1124q-5.16,10.08-10.27,20c-6.73,13.32-13.69,26.32-20.5,39.12-13.64,25.59-27.33,50.06-40.7,73s-26.47,44.46-39,64c-6.12,9.86-12.4,19.06-18.3,27.86l-8.62,12.84c-2.84,4.13-5.72,8.06-8.45,11.91-5.53,7.66-10.53,15-15.47,21.47l-13.65,17.85-5.87,7.63-5.42,6.55-8.54,10.32-7.12,8.6a4.07,4.07,0,1,1-6.27-5.2h0l.11-.14,7.08-8.47,8.51-10.18,5.4-6.46,5.85-7.54,13.63-17.64c4.93-6.45,9.94-13.67,15.46-21.25,2.73-3.81,5.61-7.71,8.46-11.8l8.63-12.73c5.91-8.71,12.19-17.83,18.33-27.63,12.6-19.38,25.72-40.72,39.18-63.55s27.21-47.18,40.93-72.64c6.86-12.74,13.86-25.66,20.64-38.92l10.34-19.94,10.19-20.27c3.39-6.79,6.87-13.58,10.23-20.45s6.7-13.78,10.06-20.69c6.8-13.79,13.3-27.79,19.92-41.73s13-28,19.43-42q9.45-21,18.8-41.86c12.25-27.82,24.15-55.26,35.33-82s21.82-52.59,31.75-77.2q7.37-18.48,14.3-35.92t13.11-33.66c8.32-21.61,15.85-41.47,22.4-59.11s12.18-33,16.77-45.76c9.14-25.43,14.12-40,14.12-40a1.72,1.72,0,0,1,2.19-1.07A1.71,1.71,0,0,1,2047.24,561.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.13,1017.69a6,6,0,0,1,8.64-7.79c49.87,33.79,183.43,118.27,290.81,132.22,174.85,22.73,371.81,133.16,384.42,266C745,1408.08,380.43,1616.81,61.13,1017.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.85,1072.12l1.36,1.23,4,3.35c3.58,3,9,7.24,15.79,12.66s15.22,11.91,24.93,19.22,20.74,15.43,32.79,24.3,25.26,18.23,39.37,27.95,29.1,19.8,44.67,30.13,31.85,20.72,48.57,31l12.58,7.74,12.76,7.6c8.49,5.14,17.16,10,25.79,15s17.41,9.68,26,14.58l26.07,14c8.73,4.45,17.32,9,25.95,13.25l12.86,6.29c4.25,2.1,8.48,4.15,12.74,6.08,16.9,7.92,33.42,15.18,49.2,21.79s30.9,12.35,44.93,17.47l20.26,7c6.46,2.12,12.65,4,18.43,5.81l8.41,2.61,7.9,2.16,13.93,3.79c8.44,2.13,15.14,3.58,19.67,4.69l7,1.64h0a1,1,0,0,1,.76,1.22,1,1,0,0,1-1.19.77l-7.05-1.4c-4.59-1-11.37-2.16-19.9-4.1l-14.08-3.45-8-2-8.51-2.4c-5.85-1.7-12.13-3.37-18.66-5.39L583.79,1350c-14.18-4.92-29.48-10.43-45.44-16.85s-32.62-13.57-49.65-21.45c-4.28-1.91-8.55-4-12.83-6l-12.95-6.25c-8.69-4.21-17.34-8.75-26.13-13.17l-26.26-14c-8.69-4.85-17.46-9.66-26.1-14.7s-17.32-10-25.82-15.19l-12.77-7.69-12.58-7.81c-16.73-10.36-32.95-21-48.58-31.29s-30.45-20.77-44.41-30.76-27.06-19.6-39.09-28.55c-24-18-43.41-33.68-56.91-44.79-6.74-5.58-12-10-15.49-13.13-1.76-1.52-3.15-2.8-4.07-3.61l-1.32-1.27a1,1,0,0,1,1.38-1.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 89.39,
    y: 845.5,
    width: 33.03,
    height: 242.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 144.58,
    y: 928.86,
    width: 33.03,
    height: 159.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 199.76,
    y: 722.84,
    width: 33.03,
    height: 365.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 254.94,
    y: 1000.31,
    width: 33.03,
    height: 87.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 310.13,
    y: 771.67,
    width: 33.03,
    height: 316.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 365.31,
    y: 826.44,
    width: 33.03,
    height: 261.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 420.49,
    y: 885.99,
    width: 33.03,
    height: 202.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 475.67,
    y: 649.01,
    width: 33.03,
    height: 439.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 530.86,
    y: 695.45,
    width: 33.03,
    height: 392.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 586.04,
    y: 765.71,
    width: 33.03,
    height: 322.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 641.22,
    y: 1008.45,
    width: 33.03,
    height: 79.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1748.83,454.71a5.21,5.21,0,0,0-10.11.06c-12.24,51-48.52,183.58-109.34,255.53-99,117.15-160.84,303.63-91.05,396.36C1538.33,1106.66,1895,1027,1748.83,454.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1741.71,527.11l-.1,1.6c-.11,1.07-.28,2.65-.49,4.72-.44,4.06-1.17,10-2.21,17.53-2.14,15.06-5.42,36.55-10.21,62.19-2.47,12.81-5.17,26.67-8.34,41.28s-6.62,30-10.45,45.84c-4,15.81-8.19,32.13-12.86,48.61q-1.75,6.18-3.5,12.41l-3.7,12.43c-2.41,8.32-5.08,16.6-7.67,24.91s-5.41,16.55-8.15,24.77q-4.38,12.24-8.7,24.36c-3.07,8-6,16-9.09,23.8s-6.1,15.54-9.37,23c-6.33,15-12.76,29.47-19.36,42.91s-13.13,26-19.37,37.47l-9.26,16.29c-3,5.13-6.09,9.88-8.87,14.4-1.4,2.26-2.76,4.43-4.07,6.54s-2.72,4-4,5.94l-7,10.47c-4.35,6.25-8,11-10.42,14.28l-3.72,5a1,1,0,0,1-1.66-1.18l0,0,3.51-5.16c2.26-3.37,5.69-8.24,9.86-14.57l6.7-10.61,3.8-6,3.86-6.61c2.63-4.57,5.5-9.4,8.4-14.55s5.81-10.66,8.92-16.37c6-11.51,12.35-24.07,18.58-37.58s12.59-27.86,18.8-42.86c3.2-7.46,6.07-15.21,9.18-23s5.9-15.74,8.9-23.72l8.51-24.3c2.67-8.21,5.58-16.37,8.19-24.63s5.32-16.49,7.77-24.77q1.88-6.19,3.74-12.36l3.55-12.35c4.74-16.39,9-32.63,13.06-48.37s7.79-31,11.08-45.54,6.29-28.31,9-41,5-24.44,6.87-34.83,3.52-19.47,4.79-27,2.2-13.37,2.76-17.39c.27-2,.49-3.48.63-4.5s.15-1.58.15-1.58l0-.12a1,1,0,0,1,2,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M768.38,300.71h695.36a72,72,0,0,1,72,68.37L1587,1377.23a53.14,53.14,0,0,1-52.09,55.82l-797,14.48a50.42,50.42,0,0,1-51.34-50.41V382.48A81.77,81.77,0,0,1,768.38,300.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M854.43,1430.4h0l-89.18-1.16a55,55,0,0,1-54.08-54.78V1239.82a1.91,1.91,0,0,1,3.81,0v134.64a51.18,51.18,0,0,0,50.32,51l89.18,1.15a1.91,1.91,0,0,1,0,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M713.06,1200a1.91,1.91,0,0,1-1.91-1.9v-21.81a1.91,1.91,0,0,1,3.81,0v21.81A1.9,1.9,0,0,1,713.06,1200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M766.52,292.54c95,12.87,421.49,52.7,691.47,32a22,22,0,0,1,23.65,20.71l53.82,1012.64a25.27,25.27,0,0,1-23.74,26.58c-113.55,6.72-581.17,32.7-748,15.23a20,20,0,0,1-17.91-19.82L739.58,316.23A23.74,23.74,0,0,1,766.52,292.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M776.69,318.8c91.38,12.4,405.62,50.72,665.43,30.78a21.13,21.13,0,0,1,22.76,19.93l51.8,974.51a24.32,24.32,0,0,1-22.85,25.58c-109.27,6.47-559.29,31.47-719.8,14.66a19.27,19.27,0,0,1-17.24-19.08l-6-1023.58A22.87,22.87,0,0,1,776.69,318.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M835.36,416.74l9.7,208.92A13.29,13.29,0,0,0,858,638.33c38.7,1.09,159.27,4,227.34.48a14.82,14.82,0,0,0,14-14.33c1.3-39.19,4.14-153.23-4.79-200.9A16.75,16.75,0,0,0,1078.66,410L850,402A14.12,14.12,0,0,0,835.36,416.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 966.96,
    cy: 491.43,
    r: 44.91,
    transform: "translate(361.06 1391.1) rotate(-82.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M898.74,623.29h143.09a11.08,11.08,0,0,0,9.3-17.08c-12.15-19-37.58-47-81.62-45.69-42.45,1.21-67.6,26.45-80.25,44.55A11.58,11.58,0,0,0,898.74,623.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1411.69,434.92a3.87,3.87,0,0,0,3.88-4l-.17-6a4.25,4.25,0,0,0-4.12-4.07l-259.09-4.61a2.6,2.6,0,0,0-2.67,3.7l4,11.23a6.07,6.07,0,0,0,5.33,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1152.19,455.16a2.61,2.61,0,0,0-2.67,3.71l4,11.23a6.07,6.07,0,0,0,5.33,3.77h252.88a3.87,3.87,0,0,0,3.88-4l-.17-6a4.25,4.25,0,0,0-4.12-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1152.19,494.68a2.6,2.6,0,0,0-2.67,3.7l4,11.23a6.07,6.07,0,0,0,5.33,3.78h252.88a3.87,3.87,0,0,0,3.88-4l-.17-6a4.25,4.25,0,0,0-4.12-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1436.05,704a3.7,3.7,0,0,0,3.73-4l-.39-6a4.38,4.38,0,0,0-4.27-4l-595.83-4.7c-2.2,0-2.88,1.38-1.51,3.1l10,12.52a9.42,9.42,0,0,0,6.49,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M839.29,724.15c-2.2,0-2.88,1.38-1.51,3.1l10,12.52a9.41,9.41,0,0,0,6.49,3.12h581.81a3.69,3.69,0,0,0,3.73-4l-.39-6a4.38,4.38,0,0,0-4.27-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M840.79,789.21c14.12-1.08,40.58-1.58,55.14-1.79a13.21,13.21,0,0,1,13,10.1c2.81,11.65,6.69,31.88,6.2,53.31a11.73,11.73,0,0,1-11.83,11.48l-53.73-.58A12.9,12.9,0,0,1,836.89,850l-4.73-50.56A9.4,9.4,0,0,1,840.79,789.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M936,809.8a3.18,3.18,0,0,0-3.4,3.79l2.53,16.86a4.8,4.8,0,0,0,4.59,4h138.81a4,4,0,0,0,4-4l-.13-10.5a4.3,4.3,0,0,0-4-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1133.54,789.21c14.13-1.08,40.59-1.58,55.15-1.79a13.21,13.21,0,0,1,13,10.1c2.81,11.65,6.68,31.88,6.2,53.31a11.73,11.73,0,0,1-11.83,11.48l-53.74-.58a12.9,12.9,0,0,1-12.71-11.7l-4.72-50.56A9.4,9.4,0,0,1,1133.54,789.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1228.78,809.8a3.19,3.19,0,0,0-3.41,3.79l2.54,16.86a4.8,4.8,0,0,0,4.59,4h138.81a4,4,0,0,0,4-4l-.13-10.5a4.3,4.3,0,0,0-4.05-4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M916.61,989.79h-.14l-49.58-.48c-7.09-.07-12.94-4.94-13.61-11.34l-4.36-41.6a9.07,9.07,0,0,1,2.14-6.8,10.92,10.92,0,0,1,7.59-3.75h0c4.17-.28,10.06-.78,16.29-1.31,13.11-1.12,29.43-2.51,38.62-2.62,6.66,0,12.31,3.91,13.88,9.71,2.59,9.55,2.36,27.63,1.87,46.89C929.15,984.74,923.46,989.79,916.61,989.79Zm-57.7-60.17A7.09,7.09,0,0,0,854,932a5.25,5.25,0,0,0-1.26,4l4.36,41.61c.47,4.46,4.7,7.87,9.85,7.92l49.59.48h.1c4.8,0,8.78-3.39,8.89-7.59.48-19,.72-36.74-1.73-45.8-1.1-4.06-5.32-6.88-10.16-6.9-9.05.12-25.3,1.5-38.35,2.61-6.25.53-12.15,1-16.35,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M864.24,933.92c10.42-.71,33.06-3,43.8-3.15,4.55,0,8.54,2.7,9.6,6.64,2.08,7.66,1.8,22.94,1.44,37-.11,4.22-4,7.59-8.72,7.54l-39.62-.38c-4.88,0-8.92-3.37-9.38-7.69l-3.48-33.25C857.52,937.23,860.38,934.18,864.24,933.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M960.16,962.16a12.32,12.32,0,0,0,12,9.17L1431,967.42a9.31,9.31,0,0,0,0-18.62l-458.82-2.09A12.32,12.32,0,0,0,960.16,962.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M866.35,940.44h0a7.61,7.61,0,0,1,10.5,2.86l9.78,17.53a2.44,2.44,0,0,0,4.36-.19l24.26-54a2.71,2.71,0,0,1,5.18,1.17c-.25,16.52-4.63,47.93-31,74.21,0,0-14.54-5.65-26.26-31.38A8,8,0,0,1,866.35,940.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M916.61,1096.06h-.14l-49.58-.47c-7.09-.07-12.94-4.94-13.61-11.34l-4.36-41.6a9.07,9.07,0,0,1,2.14-6.8,10.88,10.88,0,0,1,7.59-3.75h0c4.17-.28,10.06-.78,16.29-1.31,13.11-1.12,29.43-2.51,38.62-2.63h.2c6.52,0,12.13,4,13.68,9.72,2.59,9.55,2.36,27.63,1.87,46.89C929.15,1091,923.46,1096.06,916.61,1096.06Zm-57.7-60.16a7.09,7.09,0,0,0-4.94,2.4,5.24,5.24,0,0,0-1.26,4l4.36,41.6c.47,4.47,4.7,7.88,9.85,7.93l49.59.48h.1c4.8,0,8.78-3.39,8.89-7.59.48-19,.72-36.74-1.73-45.8-1.1-4.06-5.38-7-10.17-6.9-9,.12-25.29,1.5-38.34,2.61-6.25.53-12.15,1-16.35,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M864.24,1040.2c10.42-.72,33.06-3,43.8-3.15,4.55,0,8.54,2.69,9.6,6.64,2.08,7.66,1.8,22.94,1.44,37-.11,4.23-4,7.6-8.72,7.55l-39.62-.38c-4.88-.05-8.92-3.37-9.38-7.7L857.88,1047C857.52,1043.51,860.38,1040.46,864.24,1040.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M960.16,1068.44a12.32,12.32,0,0,0,12,9.17L1431,1073.7a9.31,9.31,0,0,0,0-18.62L972.12,1053A12.32,12.32,0,0,0,960.16,1068.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M866.35,1046.72h0a7.61,7.61,0,0,1,10.5,2.86l9.78,17.53a2.44,2.44,0,0,0,4.36-.19l24.26-54a2.71,2.71,0,0,1,5.18,1.17c-.25,16.52-4.63,47.92-31,74.21,0,0-14.54-5.65-26.26-31.38A8,8,0,0,1,866.35,1046.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M916.61,1202.34h-.14l-49.58-.47c-7.09-.07-12.94-4.94-13.61-11.34l-4.36-41.6a9.1,9.1,0,0,1,2.14-6.81,10.91,10.91,0,0,1,7.59-3.74h0c4.17-.28,10.06-.79,16.29-1.32,13.11-1.11,29.43-2.5,38.62-2.62h.2c6.52,0,12.13,4,13.68,9.71,2.59,9.56,2.36,27.63,1.87,46.89C929.15,1197.3,923.46,1202.34,916.61,1202.34Zm-57.7-60.16a7.05,7.05,0,0,0-4.94,2.4,5.24,5.24,0,0,0-1.26,4l4.36,41.6c.47,4.47,4.7,7.88,9.85,7.93l49.59.48h.1c4.8,0,8.78-3.39,8.89-7.59.48-19,.72-36.74-1.73-45.8-1.1-4.06-5.38-7-10.17-6.9-9,.11-25.29,1.5-38.34,2.61-6.25.53-12.15,1-16.35,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M864.24,1146.47c10.42-.71,33.06-3,43.8-3.14,4.55-.06,8.54,2.69,9.6,6.64,2.08,7.66,1.8,22.93,1.44,37-.11,4.22-4,7.59-8.72,7.55l-39.62-.38c-4.88-.05-8.92-3.37-9.38-7.7l-3.48-33.25C857.52,1149.78,860.38,1146.74,864.24,1146.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M960.16,1174.72a12.32,12.32,0,0,0,12,9.17L1431,1180a9.31,9.31,0,0,0,0-18.62l-458.82-2.1A12.33,12.33,0,0,0,960.16,1174.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M866.35,1153h0a7.61,7.61,0,0,1,10.5,2.86l9.78,17.53a2.44,2.44,0,0,0,4.36-.19l24.26-54a2.71,2.71,0,0,1,5.18,1.17c-.25,16.52-4.63,47.92-31,74.21,0,0-14.54-5.66-26.26-31.38A8,8,0,0,1,866.35,1153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M916.61,1308.62h-.14l-49.58-.48c-7.09-.06-12.94-4.94-13.61-11.33l-4.36-41.61a9.09,9.09,0,0,1,2.14-6.8,10.87,10.87,0,0,1,7.59-3.74h0c4.17-.29,10.06-.79,16.29-1.32,13.11-1.12,29.43-2.5,38.62-2.62h.2c6.52,0,12.13,4,13.68,9.71,2.59,9.55,2.36,27.63,1.87,46.89C929.15,1303.58,923.46,1308.62,916.61,1308.62Zm-57.7-60.16a7.08,7.08,0,0,0-4.94,2.39,5.28,5.28,0,0,0-1.26,4l4.36,41.6c.47,4.47,4.7,7.88,9.85,7.93l49.59.47h.1c4.8,0,8.78-3.38,8.89-7.58.48-19,.72-36.75-1.73-45.8-1.1-4.06-5.38-7-10.17-6.9-9,.11-25.29,1.49-38.34,2.61-6.25.53-12.15,1-16.35,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M864.24,1252.75c10.42-.71,33.06-3,43.8-3.14,4.55-.06,8.54,2.69,9.6,6.64,2.08,7.66,1.8,22.93,1.44,37-.11,4.22-4,7.59-8.72,7.55l-39.62-.38c-4.88,0-8.92-3.37-9.38-7.7l-3.48-33.25C857.52,1256.06,860.38,1253,864.24,1252.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M960.16,1281h0a12.32,12.32,0,0,0,12,9.17l458.81-3.91a9.31,9.31,0,0,0,0-18.62l-458.82-2.1A12.32,12.32,0,0,0,960.16,1281Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M866.35,1259.28h0a7.62,7.62,0,0,1,10.5,2.85l9.78,17.54a2.44,2.44,0,0,0,4.36-.19l24.26-54a2.71,2.71,0,0,1,5.18,1.17c-.25,16.52-4.63,47.92-31,74.21,0,0-14.54-5.66-26.26-31.38A8,8,0,0,1,866.35,1259.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1159.19,163.25c-25.12-17.47-47-17.13-62.33-12.59a30.66,30.66,0,0,0-21.78,32.24l6.63,72.37,78.89,7S1208.45,197.52,1159.19,163.25Zm-34.7,58.39A19.68,19.68,0,1,1,1144.17,202,19.68,19.68,0,0,1,1124.49,221.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1089.59,224.83a1.9,1.9,0,0,1-1.9-1.73l-1-11.53a1.9,1.9,0,1,1,3.79-.34l1.06,11.52a1.91,1.91,0,0,1-1.73,2.07Zm-2.07-22.59a1.9,1.9,0,0,1-1.89-1.73l-.81-8.75a29.27,29.27,0,0,1,20.76-30.71,58.86,58.86,0,0,1,28.83-1.18,1.9,1.9,0,0,1-.76,3.73,55.2,55.2,0,0,0-27,1.1,25.47,25.47,0,0,0-18,26.72l.81,8.75a1.92,1.92,0,0,1-1.73,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M974,302V265.65a22.2,22.2,0,0,1,23-22.19l250.86,8.6a21.59,21.59,0,0,1,20.81,20.29l2.1,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1067.56,257.17h-10.78a1.9,1.9,0,1,1,0-3.8h10.78a1.9,1.9,0,1,1,0,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M987.6,290.61a1.9,1.9,0,0,1-1.9-1.9V274a20.65,20.65,0,0,1,20.63-20.62H1046a1.9,1.9,0,1,1,0,3.8h-39.66A16.84,16.84,0,0,0,989.51,274v14.72A1.9,1.9,0,0,1,987.6,290.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M895.42,288.72H1334.1a32.43,32.43,0,0,1,32,26.89l.37,2.15A27.85,27.85,0,0,1,1339,350.34H888.93a18.11,18.11,0,0,1-18.09-19l1-20.14A23.65,23.65,0,0,1,895.42,288.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1731.96,
    y: 1276.49,
    width: 16.58,
    height: 179.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1672,1448.45h136.21a4.67,4.67,0,0,1,4.67,4.67v6.12a0,0,0,0,1,0,0H1667.65a0,0,0,0,1,0,0v-6.46A4.33,4.33,0,0,1,1672,1448.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1651.84,
    y: 1236.32,
    width: 182.57,
    height: 51.78,
    rx: 17.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1617.86,1157s-24.64,3.82-52.33,22.33a13.84,13.84,0,0,0-6.1,13.2c3.32,26.27,17,111.3,61.92,194.35a20.91,20.91,0,0,1,2,14.35l-7.81,36.36-14.49,13.58h37.32l24.84-67.24-10.62-3.36a20.1,20.1,0,0,1-14-18.82l-1.25-72.13c1.07-32.13-19.7-54.31-19.7-54.31l59.6-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1586.49,1457.68c-3.4,4.45,36.58,10.32,56.77.59,0,0,28-48.71,28-73.79,0,0-2.22-5.12-18.66-4,0,0-9.4,57.68-19.33,64.14s-27.77.65-27.77.65S1591.5,1451.12,1586.49,1457.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1669.67,1236.32c-.32-.55-64.17-7.68-64.17-7.68s2.09,19.42-4.44,46.14-100.27,142.51-100.27,142.51l9.83,31.16c-30.4,10.58-60.29,12.28-89.71,5.39l60.92-36.55s57-194.28,91.93-228.94l64-22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1812.85,1123.28s36.79,54.71,39.81,79.67-10.08,35.1-48.68,36.77-141.63,1.65-141.63,1.65l-87.95-75.16s64.09-22.87,80.75-29.34S1812.85,1123.28,1812.85,1123.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1506.9,1438s10.58,10.25,3.44,21.66c0,0-83.83,14.86-106.59,8.11,0,0,4.72-10.78,30.35-23.06l-1.89,1.45a3.06,3.06,0,0,0,2,5.49C1451.12,1450.64,1486.07,1447.55,1506.9,1438Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1735.94,801.78c5.56,1.73,25.6,8.92,23,21.81a2.36,2.36,0,0,0,3,2.7c8.64-2.32,27.71-5.25,39.53,9.56,10.44,13.08,2.64,25.42-3.72,32.2a2.37,2.37,0,0,0,2,4c15.87-2,50.36-2.48,56,29.82,5.27,30.13-15.7,38.63-28.14,41a2.36,2.36,0,0,0-.79,4.32c6.21,3.94,13.39,12.07,10.49,28.12-4.55,25.16-53.88,23.1-59.64,22.78a2.47,2.47,0,0,1-1-.31l-79-45.06a2.38,2.38,0,0,1-1.16-1.66l-16-92.12a2.36,2.36,0,0,1,.63-2.05l39.57-56.87C1711.64,795.13,1735.09,801.51,1735.94,801.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1710.8,1101.9s-42.84-40.79-63.92-67.8a57.33,57.33,0,0,1-9.71-51.59c9.63-32.44,26.74-66,28.3-71.26,2.39-8,50.42-7.68,50.42-7.68s94.52,61.35,131.65,165.25l-41.7,13s-24.68-41.4-49.06-67.73c0,0,42.19,55.74,43.67,78.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1659.66,866.47c.5,1.66,13,43.22,14,44.08s27.49,2.29,40-6.24l-23.82-54.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1655.72,775.16s-19.34,15.15-25.62,50.74,8.75,47.16,23.23,45.38,35.22-7.74,51.73-34.11S1681.15,756.52,1655.72,775.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1685.67,824.34s3.95-50.65-37.14-40.08l-7.81,9.34s-22-21.52-.62-40.44,52.93-16.64,72.43,13.73,27.34,52.12,14.19,72.75-25.23,4.56-25.23,4.56,5.48-17.45-.55-24.35-12.35,5.12-12.35,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1686.66,837.94s1.87-26,15.56-19.59-3.07,24.43-9.86,30.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1623.53,1104.93,1655,1074.6l43.53,18.39s43.34,6.71,68.15,0l24.8-6.71,56-17.46,8.81,24.88a15,15,0,0,1-5.48,17.21c-4.84,3.45-10.53,7.24-14.15,8.82-7.38,3.23-182-2.23-182-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M319.69,1249.47c-4.76,7-23.68,166.52-26.64,225.42a7,7,0,0,0,7,7.3h0a7,7,0,0,0,6.89-5.9l34.61-221.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M471.79,1249.47c4.76,7,23.68,166.52,26.64,225.42a7,7,0,0,1-7,7.3h0a7,7,0,0,1-6.9-5.9L450,1254.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M291.07,1237v1.73c-.12,12.52,10.66,22.78,24.16,23l159.94,2.72c13.3.22,24.39-9.39,25-21.71l.09-1.59c.67-12.84-10.24-23.66-24.11-23.91l-160-2.87C302.47,1214.16,291.19,1224.33,291.07,1237Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M664.86,863.47l-4.16-6.78a15.06,15.06,0,0,0-11-7.06l-44.34-5.5s-2-5,6.18-10.87,3.33-15.5,3.33-15.5S604,826.7,588.22,840.47c-9,7.88-12.44,18.48-13.73,26.11l-7.09,15.56c4,4.67,10.08,8.37,19.39,7.19l1.61-11.91C615.07,878.29,640.44,873.09,664.86,863.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M567.4,882.14,541.05,939.9a25.26,25.26,0,0,1-31.76,13.21l-54-48-1.19,96.34,56.27,11.27a55.67,55.67,0,0,0,66.09-47.11l10.33-76.3C577.48,890.51,571.36,886.81,567.4,882.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M602.22,1469.1c-28.43,0-41-2.44-46.63-4.67a10.79,10.79,0,0,0,10.51,8.36H666.68a4.9,4.9,0,0,0,4.71-6.18C659.93,1467.53,635.58,1469.1,602.22,1469.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M671.39,1466.61a4.65,4.65,0,0,0-.82-1.71c-7.66-9.78-23.05-25.15-44-24.85-30.67.43-41.36,3.76-65.2.18l-5.62,18.64a10.75,10.75,0,0,0-.17,5.56c5.62,2.23,18.2,4.67,46.63,4.67C635.58,1469.1,659.93,1467.53,671.39,1466.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M568.28,1420.15l-6.9,23.47s15.29,7,28.74,1.38l2.64-20.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M776.75,1454.31c-22.16,17.81-33.49,23.8-39.26,25.59a10.78,10.78,0,0,0,13.4-.09l78.41-63a4.88,4.88,0,0,0-.18-7.75C820.76,1417,802.75,1433.42,776.75,1454.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M829.12,1409.06a4.52,4.52,0,0,0-1.71-.81c-12.07-2.79-33.64-5.07-49.78,8.27-23.64,19.55-29.9,28.83-50.71,41l7.24,18a10.51,10.51,0,0,0,3.33,4.42c5.77-1.79,17.1-7.78,39.26-25.59C802.75,1433.42,820.76,1417,829.12,1409.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M420.64,1152.71s170.22,13.9,205.14,30.33-28.5,246.84-28.5,246.84-9.5,4.57-30.66-2c0,0,21.69-170,5.55-206.88l-184.3-30.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M710,1425.14c1.58,1.44,16.91,32.36,16.91,32.36s17.07-3.69,20.55-14.49l-15.36-27.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M318.12,1151.28a86.15,86.15,0,0,0-5.32,31.09c.31,24.53,20,44.44,44.53,45.66l201.23,9.17a9.67,9.67,0,0,1,8.91,7.26c4.73,18.29,27.84,74.46,140.82,186.53a9.1,9.1,0,0,0,11.27,1.23l16.09-10.16a3.7,3.7,0,0,0,1.21-5L619.7,1217a45.39,45.39,0,0,0-27.55-20.43l-171.51-43.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M317.57,1150.69s-2-99.73,17.95-193.6a151.53,151.53,0,0,1,54.35-87.62l9.32-7.33,46.63,18.94,30.27,46a108.09,108.09,0,0,1,5.08,84.79c-16.65,46.43-41.34,116.69-47,140.32C434.16,1152.15,356.92,1162.35,317.57,1150.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M431.25,787.81l-36.44,84.53s11.66,26.23,52.47,16l14.57-58.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M552.21,1072c0-1.46,46.63-157.4,46.63-157.4l51-8.74-61.21,170.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M549.29,1076.37c2.92,2.91,32.07,2.91,32.07,2.91l61.21-177.8-48.1,10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M503.45,749.26c.44,1.18,1.41,84.46,1.41,84.46l-47.57-.46-12.64-78.8S496.1,729.5,503.45,749.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M458.6,769.62l3.41,42a6.05,6.05,0,0,0,.34,1.56c1.15,3.1,5.89,13.48,16.21,8,9.37-5,18-9.4,24.73-8.83a5.88,5.88,0,0,1,5.4,5.79c.08,7.57,0,24.62-2.41,39.42a5.85,5.85,0,0,1-6.23,4.9c-9.14-.65-28.38-2.55-43.5-7.71a5.9,5.9,0,0,1-3.93-4.57c-1.79-10.4-7.36-42-10.27-50.56-2.73-8-13.92-10.79-18.7-11.61a5.81,5.81,0,0,1-3.83-2.48c-3.13-4.66-8.49-15.85,5.34-23.91a5.89,5.89,0,0,0,2-8.24c-3.52-5.65-6.48-14.81,3.92-22.46,10.56-7.77,20.64-3.42,26.45.63a5.89,5.89,0,0,0,7.52-.72,4.67,4.67,0,0,1,5.22-1,5.79,5.79,0,0,0,7.5-4.16c1.56-6.36,5.94-13.75,17.81-14.26,21.07-.92,28.24,21.1,25.73,35.46s-25.41,14-37.79,9.75c-9.41-3.26-19.06,4.38-23.14,8.23A5.81,5.81,0,0,0,458.6,769.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M443.74,814.89s3.3-25.2-6.52-29.07-21.89,1.85-15.43,18.19C429.83,824.34,443.74,814.89,443.74,814.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M569,1026.92c-103.54,71.61-147.54-91.74-148.63-92.64-67-55.38-63.84,45.15-55.38,56.83,85.65,133.51,185.08,94.73,215.8,53.75C573.43,1038.72,570.21,1032.31,569,1026.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M473.29,1029.31a3.05,3.05,0,0,1-2-.72c-25.79-21.69-42.37-57.81-51.74-84.28a3.06,3.06,0,0,1,5.76-2c7.47,21.09,23.88,59.74,49.91,81.64a3.06,3.06,0,0,1-2,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M452.64,1075.94a3,3,0,0,1-1.18-.24c-33-13.84-63.5-42.23-90.55-84.39a3.05,3.05,0,1,1,5.14-3.3c26.37,41.1,55.9,68.71,87.77,82a3.06,3.06,0,0,1-1.18,5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M626,972.26s-.94,3.55-11.14,18.12-21.87,24.78-16,7.29-1.45-23.32-8.39-4.27S577,1021,577,1021q-4.07,3.21-8,5.93c1.26,5.39,4.48,11.8,11.79,17.94,4.17-3,6.45-4.93,6.45-4.93s33.51-17.48,36.43-35A185.32,185.32,0,0,0,626,972.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M624,1124.49c-.75,3.12-72.84,273.5-91.12,342a12.39,12.39,0,0,0,11.86,15.65h0a12.31,12.31,0,0,0,11.92-9.42l80-324.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M663.49,1123.7c.75,3.13,72.84,274.1,91.12,342.8a12.41,12.41,0,0,1-11.86,15.69h0a12.32,12.32,0,0,1-11.92-9.44l-80-325.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M666.49,1115.65h-44.9v36a9.33,9.33,0,0,0,9.27,9.39H637v81a7.07,7.07,0,0,0,7,7.1h0a7.06,7.06,0,0,0,7-7.1v-81h3.13a12.38,12.38,0,0,0,12.3-12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1613.47,1124.49c-.75,3.12-72.85,273.5-91.12,342a12.39,12.39,0,0,0,11.86,15.65h0a12.3,12.3,0,0,0,11.91-9.42l80-324.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1653,1124.49c.75,3.12,72.84,273.5,91.12,342a12.39,12.39,0,0,1-11.86,15.65h0a12.31,12.31,0,0,1-11.92-9.42l-80-324.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1656,1115.65h-44.9v36a9.33,9.33,0,0,0,9.27,9.39h6.16v81a7.06,7.06,0,0,0,7,7.1h0a7.06,7.06,0,0,0,7-7.1v-81h3.13a12.38,12.38,0,0,0,12.3-12.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M507.89,1107H1768.61a7.71,7.71,0,0,1,7.44,5.84l3.5,13.72a7.76,7.76,0,0,1-7.49,9.72l-1267.25-1.49a7.76,7.76,0,0,1-7.41-9.68l3-12.23A7.71,7.71,0,0,1,507.89,1107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M355.88,880.84,352.1,876a3.09,3.09,0,0,1,4.85-3.83l0,0,3.72,4.84a3.06,3.06,0,0,1-4.82,3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M343.62,864.23l-3.34-5.11a3.21,3.21,0,0,1,5.37-3.51l0,0,3.28,5.15a3.17,3.17,0,0,1-5.33,3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M332.87,846.61,330,841.22a3.32,3.32,0,1,1,5.85-3.13v0l2.83,5.42a3.29,3.29,0,0,1-5.81,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M323.67,828.13l-2.42-5.61a3.43,3.43,0,1,1,6.3-2.73l0,0,2.36,5.64a3.4,3.4,0,0,1-6.26,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M316,808.94l-2-5.78a3.55,3.55,0,1,1,6.72-2.28v0l1.9,5.81a3.51,3.51,0,0,1-6.67,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M310,789.21l-1.5-5.92a3.66,3.66,0,0,1,7.1-1.8v0l1.44,5.94a3.63,3.63,0,0,1-7.05,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M305.43,769.08l-1.05-6a3.78,3.78,0,1,1,7.44-1.3v0l1,6a3.74,3.74,0,0,1-7.38,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M302.41,748.66l-.61-6.08a3.89,3.89,0,0,1,7.74-.78v0l.55,6.09a3.86,3.86,0,0,1-7.68.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M300.86,728.07l-.18-6.11a4,4,0,1,1,8-.23v0l.11,6.11a4,4,0,0,1-7.94.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M300.75,707.43l.24-6.11a4.12,4.12,0,1,1,8.24.32v.05l-.31,6.1a4.09,4.09,0,0,1-8.17-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M302.06,686.82l.65-6.07a4.23,4.23,0,1,1,8.42.9v.05l-.72,6.06a4.2,4.2,0,0,1-8.35-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M304.74,666.35l1.06-6a4.35,4.35,0,1,1,8.57,1.51v0l-1.12,6a4.32,4.32,0,0,1-8.5-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M308.83,646.09l1.47-5.93a4.41,4.41,0,1,1,8.56,2.12v0l-1.51,5.92a4.39,4.39,0,0,1-8.52-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M314.28,626.16l1.86-5.82a4.47,4.47,0,0,1,8.51,2.73v0l-1.89,5.81a4.45,4.45,0,0,1-8.47-2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321.05,606.63,323.3,601a4.53,4.53,0,1,1,8.42,3.34v0L329.42,610a4.51,4.51,0,0,1-8.37-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M329.14,587.6l2.64-5.52a4.59,4.59,0,1,1,8.28,4v0l-2.68,5.5a4.57,4.57,0,0,1-8.23-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M338.54,569.15l3-5.31a4.65,4.65,0,0,1,8.08,4.59v0l-3.06,5.3a4.63,4.63,0,0,1-8-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M349.23,551.42l3.4-5.08a4.71,4.71,0,1,1,7.83,5.23l0,0L357,556.66a4.69,4.69,0,0,1-7.78-5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M361.18,534.51l3.74-4.83a4.77,4.77,0,0,1,7.54,5.84l0,0-3.77,4.8a4.75,4.75,0,0,1-7.49-5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M374.21,518.46l4.05-4.57a4.82,4.82,0,1,1,7.23,6.39l0,0-4.07,4.56a4.81,4.81,0,0,1-7.19-6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M388.24,503.29l4.33-4.32a4.89,4.89,0,1,1,6.9,6.92l0,0-4.35,4.29a4.87,4.87,0,0,1-6.86-6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M403.2,489l4.58-4a4.95,4.95,0,1,1,6.54,7.42l0,0-4.61,4A4.93,4.93,0,0,1,403.2,489Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M419,475.69l4.82-3.76a5,5,0,1,1,6.16,7.89l0,0-4.84,3.73a5,5,0,0,1-6.12-7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M435.52,463.32l5-3.48a5.07,5.07,0,1,1,5.76,8.34l0,0-5.05,3.44a5,5,0,0,1-5.72-8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M452.74,451.91l5.21-3.18a5.12,5.12,0,1,1,5.35,8.74l0,0-5.23,3.16a5.11,5.11,0,0,1-5.31-8.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M470.56,441.48l5.38-2.89a5.18,5.18,0,0,1,4.9,9.12h0l-5.39,2.88a5.17,5.17,0,0,1-4.88-9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M488.93,432.07l5.53-2.6a5.19,5.19,0,0,1,4.41,9.39h0l-5.54,2.6a5.18,5.18,0,0,1-4.4-9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M507.76,423.63l5.66-2.31a5.2,5.2,0,1,1,3.93,9.63h0l-5.66,2.31a5.2,5.2,0,0,1-3.92-9.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M527,416.17l5.76-2a5.22,5.22,0,1,1,3.46,9.84h0l-5.76,2a5.21,5.21,0,1,1-3.45-9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M546.56,409.68l5.86-1.73a5.23,5.23,0,1,1,3,10h0l-5.86,1.73a5.22,5.22,0,0,1-3-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M566.43,404.16l6-1.45a5.24,5.24,0,1,1,2.48,10.18h0l-6,1.44a5.23,5.23,0,0,1-2.48-10.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M586.55,399.61l6-1.17a5.25,5.25,0,0,1,2,10.31h0l-6,1.16a5.25,5.25,0,0,1-2-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M606.86,396l6-.87a5.26,5.26,0,1,1,1.51,10.42h0l-6,.87A5.26,5.26,0,0,1,606.86,396Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M627.31,393.42l6.08-.59a5.28,5.28,0,0,1,1,10.51h0l-6.09.57a5.27,5.27,0,0,1-1-10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M647.87,391.79l6.11-.29a5.29,5.29,0,0,1,.5,10.57h0l-6.12.28a5.29,5.29,0,0,1-.49-10.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M668.48,391.16h6.15a5.3,5.3,0,1,1,0,10.6h-6.15a5.3,5.3,0,0,1,0-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M689.09,391.51l6.11.27a5.32,5.32,0,1,1-.48,10.62h0l-6.1-.28a5.31,5.31,0,0,1,.48-10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M709.65,392.75l6.09.53a5.33,5.33,0,0,1-.94,10.62h0l-6.09-.55a5.32,5.32,0,0,1,.94-10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M730.13,394.86l6.06.79a5.34,5.34,0,1,1-1.38,10.59h0l-6.06-.8a5.33,5.33,0,1,1,1.38-10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M750.5,397.81l6,1a5.35,5.35,0,1,1-1.81,10.55h0l-6-1a5.35,5.35,0,0,1,1.81-10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M770.73,401.57l6,1.27a5.37,5.37,0,1,1-2.23,10.5h0l-6-1.28a5.36,5.36,0,0,1,2.23-10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M790.8,406.11l5.92,1.5A5.38,5.38,0,0,1,794.09,418h0l-5.93-1.51a5.37,5.37,0,1,1,2.64-10.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M810.67,411.4l5.87,1.71a5.39,5.39,0,1,1-3,10.35h0l-5.87-1.72a5.39,5.39,0,1,1,3-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M830.34,417.39l5.8,1.92a5.4,5.4,0,1,1-3.39,10.26h0l-5.8-1.92a5.4,5.4,0,0,1,3.39-10.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M849.77,424.07l5.73,2.12a5.4,5.4,0,0,1-3.73,10.14L846,434.22a5.41,5.41,0,1,1,3.73-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M869,431.43l5.64,2.3a5.37,5.37,0,0,1-4,10l-5.66-2.29a5.38,5.38,0,1,1,4-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M887.87,439.39l5.58,2.49a5.34,5.34,0,0,1-4.33,9.77l-5.59-2.47a5.35,5.35,0,1,1,4.33-9.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M906.54,448l5.5,2.66a5.31,5.31,0,0,1-4.6,9.57l-5.52-2.64a5.32,5.32,0,1,1,4.6-9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M924.93,457.06l5.43,2.82a5.29,5.29,0,0,1-4.86,9.39l-5.44-2.8a5.3,5.3,0,0,1,4.86-9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M943.05,466.71l5.35,3a5.26,5.26,0,0,1-5.1,9.19l-5.36-3A5.27,5.27,0,0,1,943,466.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M960.88,476.87l5.27,3.12a5.23,5.23,0,0,1-5.32,9l-5.28-3.11a5.24,5.24,0,1,1,5.32-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M978.43,487.51l5.17,3.26a5.2,5.2,0,0,1-5.53,8.8l-5.18-3.25a5.2,5.2,0,1,1,5.52-8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M995.68,498.61l5.08,3.4a5.17,5.17,0,0,1-5.73,8.6l-5.09-3.38a5.17,5.17,0,1,1,5.72-8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1012.62,510.16l5,3.52a5.14,5.14,0,0,1-5.91,8.4l-5-3.5a5.15,5.15,0,1,1,5.91-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1029.25,522.08l4.92,3.63a5.11,5.11,0,0,1-6.05,8.23l-4.93-3.61a5.12,5.12,0,1,1,6-8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1045.64,534.33l4.85,3.71a5.08,5.08,0,0,1-6.16,8.08l-4.86-3.7a5.09,5.09,0,0,1,6.15-8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1061.79,546.83l4.8,3.78a5,5,0,0,1-6.23,7.94l-4.81-3.77a5.05,5.05,0,1,1,6.23-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1077.78,559.52l4.76,3.83a5,5,0,0,1-6.28,7.83l-4.77-3.82a5,5,0,1,1,6.28-7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1093.63,572.36l4.74,3.86a5,5,0,0,1-6.3,7.74l-4.74-3.85a5,5,0,1,1,6.29-7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1109.41,585.27l4.72,3.88a5,5,0,0,1-6.28,7.67l-4.74-3.87a5,5,0,0,1,6.29-7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1125.15,598.21l4.72,3.87a4.93,4.93,0,0,1-6.24,7.63l-4.74-3.86a4.94,4.94,0,0,1,6.25-7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1140.89,611.11l4.74,3.86a4.9,4.9,0,0,1-6.18,7.6l-4.75-3.84a4.91,4.91,0,0,1,6.18-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1156.69,623.91l4.77,3.83a4.87,4.87,0,0,1-6.08,7.6l-4.78-3.81a4.88,4.88,0,1,1,6.08-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1172.59,636.57l4.8,3.77a4.84,4.84,0,0,1-6,7.63l-4.82-3.76a4.85,4.85,0,0,1,6-7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1188.63,649l4.85,3.69h0a4.81,4.81,0,0,1-5.81,7.66l-4.89-3.69a4.82,4.82,0,0,1,5.81-7.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1204.84,661.19l4.93,3.6a4.78,4.78,0,0,1-5.63,7.73l-4.94-3.59a4.79,4.79,0,0,1,5.63-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1221.29,673l5,3.5a4.75,4.75,0,0,1-5.43,7.8l-5-3.48a4.76,4.76,0,0,1,5.42-7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1238,684.46l5.1,3.37a4.72,4.72,0,0,1-5.19,7.89l-5.11-3.35a4.73,4.73,0,0,1,5.19-7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1255,695.48l5.19,3.23a4.65,4.65,0,0,1-4.89,7.91l-5.21-3.2a4.67,4.67,0,0,1,4.88-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1272.25,706l5.29,3.06a4.58,4.58,0,0,1-4.57,8l-5.31-3a4.6,4.6,0,1,1,4.56-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1289.86,715.88l5.39,2.87a4.52,4.52,0,0,1-4.21,8l-5.41-2.84a4.53,4.53,0,1,1,4.2-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1307.81,725.12l5.51,2.65a4.45,4.45,0,0,1-3.83,8l-5.53-2.62a4.47,4.47,0,0,1,3.82-8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1326.13,733.61l5.61,2.41a4.38,4.38,0,0,1-3.43,8.06l-5.63-2.37a4.4,4.4,0,0,1,3.42-8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1344.78,741.26l5.71,2.15a4.31,4.31,0,0,1-3,8.08l-5.73-2.1a4.33,4.33,0,1,1,3-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1363.76,748l5.82,1.84a4.24,4.24,0,0,1-2.54,8.1l-5.83-1.81a4.26,4.26,0,1,1,2.52-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1383.06,753.73l5.91,1.52a4.17,4.17,0,0,1-2.06,8.09l-5.92-1.48a4.2,4.2,0,0,1,2-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1402.63,758.35l6,1.16a4.11,4.11,0,0,1-1.53,8.07l-6-1.12a4.13,4.13,0,0,1,1.51-8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1422.45,761.73l6.06.77a4,4,0,0,1-1,8l-6.06-.74a4.06,4.06,0,0,1,1-8.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1442.45,763.83l6.09.38a4,4,0,0,1-.46,7.93l-6.1-.34a4,4,0,1,1,.44-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1462.53,764.62l6.11,0a3.9,3.9,0,0,1,.07,7.8l-6.11.07a3.92,3.92,0,1,1-.09-7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1482.62,764l6.1-.45a3.83,3.83,0,0,1,.59,7.64l-6.09.5a3.86,3.86,0,0,1-.62-7.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1502.61,762.05l6.05-.9a3.77,3.77,0,0,1,1.13,7.45l-6,.93a3.78,3.78,0,0,1-1.16-7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1522.39,758.57l5.95-1.36a3.7,3.7,0,0,1,1.67,7.21l-5.94,1.4a3.72,3.72,0,1,1-1.71-7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1541.81,753.56l5.83-1.85a3.63,3.63,0,0,1,2.21,6.92l-5.81,1.88a3.65,3.65,0,1,1-2.25-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1560.74,746.94l5.65-2.34a3.56,3.56,0,0,1,2.75,6.56l-5.63,2.39a3.58,3.58,0,1,1-2.8-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1579,738.71l5.41-2.84a3.44,3.44,0,0,1,3.23,6.08l-5.38,2.9a3.48,3.48,0,0,1-3.3-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1596.44,728.82l5.11-3.34a3.33,3.33,0,0,1,3.67,5.55l-5.06,3.4a3.37,3.37,0,0,1-3.75-5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1612.79,717.29l4.73-3.87a3.22,3.22,0,0,1,4.1,5l-4.69,3.92a3.25,3.25,0,1,1-4.17-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1627.77,704l4.27-4.38a3.1,3.1,0,0,1,4.46,4.32l-4.22,4.42a3.14,3.14,0,0,1-4.54-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1641.22,689.18l3.77-4.81a3,3,0,0,1,4.73,3.67l-3.73,4.85a3,3,0,1,1-4.79-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1653,673l3.25-5.18a2.88,2.88,0,0,1,4.9,3L1658,676a2.91,2.91,0,0,1-5-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1663.07,655.6l2.7-5.49a2.77,2.77,0,0,1,5,2.41l-2.64,5.52a2.8,2.8,0,0,1-5-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1671.24,637.27l2.09-5.75a2.66,2.66,0,0,1,5,1.79l-2,5.77a2.69,2.69,0,0,1-5.07-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1677.39,618.16l1.44-5.94a2.54,2.54,0,0,1,4.94,1.17l-1.37,6a2.58,2.58,0,0,1-5-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1681.34,598.48l.73-6.07a2.43,2.43,0,0,1,4.83.56l-.67,6.08a2.46,2.46,0,0,1-4.9-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1682.9,578.48l0-6.11a2.32,2.32,0,0,1,4.63,0l.09,6.11a2.35,2.35,0,1,1-4.7.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1681.9,558.45l-.84-6.05a2.2,2.2,0,0,1,4.36-.63l.91,6a2.23,2.23,0,1,1-4.42.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1678.19,538.75l-1.69-5.87a2.09,2.09,0,0,1,4-1.18l1.75,5.86a2.12,2.12,0,1,1-4.07,1.21Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionSupport2);
export default __webpack_public_path__ + "static/media/production_support_2.de23adff1b3e34e5bbedbc0cc1df3425.svg";
export { ForwardRef as ReactComponent };